import React from "react";

export default function GuidanceAccordion({
  title,
  children,
  defaultOpen = false,
}) {
  return (
    <details
      data-testid="guidance-accordion"
      className="group w-full  overflow-hidden"
      open={defaultOpen}
    >
      <summary className="list-none cursor-pointer w-full min-h-[52px] py-2 flex items-center gap-3 text-left">
        <span className="flex-1 subtitle-text leading-tight">{title}</span>
        <span
          className="material-symbols-outlined text-primary text-[24px] transition-transform group-open:rotate-180"
          aria-hidden="true"
        >
          expand_more
        </span>
      </summary>
      <div className="px-2 pb-4 text-left">{children}</div>
    </details>
  );
}
